import React from 'react';
import { createRoot } from 'react-dom/client';
import BlobBrowser from './BlobBrowser';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <BlobBrowser />
  </React.StrictMode>
);